export interface ICreateWatch {
	id: Nullable<string>;
	serialNumber: string;
	restaurantId: Nullable<string>;
}

export interface IUpdateWatch {
	id: string;
	serialNumber: string;
	restaurantId: Nullable<string>;
}

export interface IDataGetWatchInfo {
	id: string;
	serialNumber: string;
	restaurantId: Nullable<string>;
	customerId: Nullable<string>;
	isActive: boolean;
	insertedBy: Nullable<string>;
	insertedDate: Nullable<string>;
	updatedBy: Nullable<string>;
	updatedDate: Nullable<string>;
}

export interface IGetWatchInfo {
	data: IDataGetWatchInfo;
}

export interface IGetPaginatedWatches {
	pageNumber: number;
	pageSize: number;
	searchBySerialNumber: Nullable<string>;
	customerId: Nullable<string>;
	restaurantId: Nullable<string>;
	isActive: Nullable<boolean>;
	sortBySerialNumber: Nullable<string>;
	sortByRestaurantAddress: Nullable<string>;
	sortByCustomerName: Nullable<string>;
}

export interface IWatches {
	count: number;
	items: {
		id: string;
		serialNumber: string;
		customerId: Nullable<string>;
		customerName: Nullable<string>;
		restaurantId: Nullable<string>;
		restaurantAddress: Nullable<string>;
		isActive: boolean;
	}[];
}

export enum WatchesNotificationTypes {
	PushDeactivateWatch = 'PushDeactivateWatch',
}

export interface IWatchNotificationsData {
	restaurantId: string;
	notificationType: WatchesNotificationTypes;
}

export type TAndroidWatchesImportantMessages = 'Order' | 'OrderPaid' | 'Alcohol' | 'CallWaiter';

export type TAndroidWatchesInformationMessages = '';

export interface IRestaurantAndroidWatchesMessagesData {
	importantMessages: TAndroidWatchesImportantMessages[];
	informationMessages: TAndroidWatchesInformationMessages[];
}

export interface IGetRestaurantAndroidWatchesMessages {
	data: IRestaurantAndroidWatchesMessagesData;
}

export interface IAndroidWatchesImportantMessagesType {
	id: TAndroidWatchesImportantMessages;
	name: TAndroidWatchesImportantMessages;
	disabled: boolean;
}

export interface IAndroidWatchesInformationMessagesType {
	id: TAndroidWatchesInformationMessages;
	name: TAndroidWatchesInformationMessages;
	disabled: boolean;
}
